// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.upload-avatar {
   border: 2px dashed #ccc;
   border-radius: 4px;
   background-color: #f9f9f9;
   width: 500px;
   height: 350px;
   padding: 20px;
   position: relative;
   text-align: center;
}

.upload-avatar:hover {
   background-color: #f4f5f7;
}

div.image-avatar {
   content: url('photo_gray.png');
   margin: 0 auto 20px;
   width: 40%;
}

.file-input {
   cursor: pointer;
   opacity: 0.0;
   position: absolute;
   top: 0;
   left: 0;
   bottom: 0;
   right: 0;
   width: 100%;
   height: 100%;
}

.upload-avatar img {
   max-width: 100%;
   max-height: 100%;
}

.word-avatar {
   font-size: 20px;
   margin-bottom: 4px;
}

.word-size-avatar {
   color: #ffa726;
   margin-top: 8px;
}

::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/account/change-avatar/change-avatar.component.css"],"names":[],"mappings":"AAAA;GACG,uBAAuB;GACvB,kBAAkB;GAClB,yBAAyB;GACzB,YAAY;GACZ,aAAa;GACb,aAAa;GACb,kBAAkB;GAClB,kBAAkB;AACrB;;AAEA;GACG,yBAAyB;AAC5B;;AAEA;GACG,8BAA4C;GAC5C,mBAAmB;GACnB,UAAU;AACb;;AAEA;GACG,eAAe;GACf,YAAY;GACZ,kBAAkB;GAClB,MAAM;GACN,OAAO;GACP,SAAS;GACT,QAAQ;GACR,WAAW;GACX,YAAY;AACf;;AAEA;GACG,eAAe;GACf,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,wBAAwB;AAC3B","sourcesContent":[".upload-avatar {\n   border: 2px dashed #ccc;\n   border-radius: 4px;\n   background-color: #f9f9f9;\n   width: 500px;\n   height: 350px;\n   padding: 20px;\n   position: relative;\n   text-align: center;\n}\n\n.upload-avatar:hover {\n   background-color: #f4f5f7;\n}\n\ndiv.image-avatar {\n   content: url('assets/images/photo_gray.png');\n   margin: 0 auto 20px;\n   width: 40%;\n}\n\n.file-input {\n   cursor: pointer;\n   opacity: 0.0;\n   position: absolute;\n   top: 0;\n   left: 0;\n   bottom: 0;\n   right: 0;\n   width: 100%;\n   height: 100%;\n}\n\n.upload-avatar img {\n   max-width: 100%;\n   max-height: 100%;\n}\n\n.word-avatar {\n   font-size: 20px;\n   margin-bottom: 4px;\n}\n\n.word-size-avatar {\n   color: #ffa726;\n   margin-top: 8px;\n}\n\n::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
